module.exports = __webpack_public_path__ + "static/media/people-fill-primary2.7a768a05.svg";